import * as referralSourceAPI from '../api/referral_sources'
import * as types             from "../mutation-types"

// initial state
const months = {
  namespace: 'referral_sources',

  state: {
    all: [],
  },

  getters: {
    referralSources: (state) => state.all,
  },

  mutations: {
    [types.CREATE_REFERRAL_SOURCE](state, source) {
      state.all.push(source)
    },
    [types.UPDATE_REFERRAL_SOURCE](state, source) {
      let index = state.all.indexOf(state.all.find(i => i.id === source.id));
      if (index === -1) {
        window.alert('error updating referral source, try refreshing');
      }

      state.all.splice(index, 1, source)
    },
    [types.DELETE_REFERRAL_SOURCE](state, source) {
      let index = state.all.indexOf(state.all.find(i => i.id === source.id));
      if (index === -1) {
        window.alert('error deleting referral source, try refreshing');
      }

      state.all.splice(index, 1)
    }
  },

  actions: {
    [types.CREATE_REFERRAL_SOURCE]: ({ commit, dispatch, state }, month) => {
      return new Promise((resolve, reject) => {
        referralSourceAPI.createReferralSource(commit, month)
                         .then(data => {
                           commit(types.CREATE_REFERRAL_SOURCE, data)
                           resolve(data)
                         })
                         .catch(error => {
                           reject(error)
                         });
      })
    },
    [types.UPDATE_REFERRAL_SOURCE]: ({ commit, dispatch, state }, month) => {
      return new Promise((resolve, reject) => {
        referralSourceAPI.updateReferralSource(commit, month)
                         .then(data => {
                           commit(types.UPDATE_REFERRAL_SOURCE, data)
                           resolve(data)
                         })
                         .catch(error => {
                           reject(error)
                         });
      })
    },
    [types.DELETE_REFERRAL_SOURCE]: ({ commit, dispatch, state }, month) => {
      return new Promise((resolve, reject) => {
        referralSourceAPI.deleteReferralSource(commit, month)
                         .then(data => {
                           commit(types.DELETE_REFERRAL_SOURCE, data)
                           resolve(data)
                         })
                         .catch(error => {
                           reject(error)
                         });
      })
    }
  },
};

export default months;



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/referral_sources/index.js
// module id = 620
// module chunks = 0